export default function nestFlatObjects(flatObjects) {
  let result = [];

  for (let i = 0; i < flatObjects.length; i++) {
    let obj = flatObjects[i];
    if (obj.parentType == null) {
      let node = new Object();
      node.id = obj.typeId;
      node.label = obj.name;
      result.push(node);
    } else {
      let node1 = new Object();
      node1.id = obj.typeId;
      node1.label = obj.name;
      let parentId = obj.parentType;
      let parentObject = findParentObject(result, parentId);
      // console.log(node1);
      // console.log(parentObject);
      if (typeof parentObject !== "undefined") {
        // console.log("Bajaga");
        // ovaj type je child node
        if (typeof parentObject.children === "undefined") {
          parentObject.children = [];
        }
        // formiramo novi node i pridružimo ga ovom parentu.
        parentObject.children.push(node1);
      }
    }
  }

  return result;
}

function findParentObject(nestedObjects, parentId) {
  // return nestedObjects.find(x => x.id == parentId);
  for (let i = 0; i < nestedObjects.length; i++) {
    if (nestedObjects[i].id == parentId) {
      let resultObject = nestedObjects[i];
      return resultObject;
    } else if (typeof nestedObjects[i].children !== "undefined") {
      let resultObject = findParentObject(nestedObjects[i].children, parentId);
      if (typeof resultObject !== "undefined") {
        return resultObject;
      }
    }
  }
  return undefined;
}
